<div class="modal fade" id="addUserModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" #addUserModal (click)="dismiss($event)">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="justify-content: end">
        <i id="dismiss-btn" class="fas fa-times clickable" (click)="dismiss($event)"></i>
      </div>
      <div class="formWrapper">
        <div class="row modalHeader">
          <div class="addUserTitle">
            <p i18n="@@admin.users.title.actions">
              admin <span class="extraBold">actions</span>
            </p>
            <p class="text-uppercase">
              <b i18n="@@admin.users.title.createnewuser">Create New User</b>
            </p>
          </div>
        </div>
        <div class="row modalBody">
          <div class="col-8 formFrame">
            <form [formGroup]="addUserForm" (ngSubmit)="addUser()" class="addUserForm">
              <div class="row">
                <label class="col-md-6 formLabel" i18n="@@admin.firstname">First name</label>
                <div class="md-form col-md-6 form-group" style="justify-content: end">
                  <input type="text" formControlName="firstNameInput" class="form-control" placeholder="name" />
                  <div *ngIf="
                      form.firstNameInput.errors &&
                      (form.firstNameInput.dirty || form.firstNameInput.touched)
                    " class="invalid-feedback">
                    <div *ngIf="form.firstNameInput.errors.required" i18n="@@validation.firstname.required">
                      First Name is required
                    </div>
                    <div *ngIf="form.firstNameInput.errors.minlength"
                      i18n="@@validation.firstname.mustcontain2characters">
                      Must contain 2 characters
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <label class="col-md-6 formLabel" i18n="@@general.lastname">Last name</label>
                <div class="md-form col-md-6 form-group" style="justify-content: end">
                  <input type="text" formControlName="lastNameInput" class="form-control" placeholder="name" />
                  <div *ngIf="
                      form.lastNameInput.errors &&
                      (form.lastNameInput.dirty || form.lastNameInput.touched)
                    " class="invalid-feedback">
                    <div *ngIf="form.lastNameInput.errors.required" i18n="@@validation.lastname.required">
                      Last Name is required
                    </div>
                    <div *ngIf="form.lastNameInput.errors.minlength"
                      i18n="@@validation.lastname.mustcontain2characters">
                      Must contain 2 characters
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <label class="col-md-6 formLabel" i18n="@@general.email">Email</label>
                <div class="md-form col-md-6 form-group" style="justify-content: end">
                  <input type="text" formControlName="mailInput" class="form-control" placeholder="name@mail.com" />
                  <div *ngIf="
                      form.mailInput.errors &&
                      (form.mailInput.dirty || form.mailInput.touched)
                    " class="invalid-feedback">
                    <div *ngIf="form.mailInput.errors.required" i18n="@@validation.email.required">
                      Email is required
                    </div>
                    <div *ngIf="form.mailInput.errors.pattern" i18n="@@validation.email.invalid">
                      Email is invalid
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <label class="col-md-6 formLabel" i18n="@@general.phone.short">Tel</label>
                <div class="md-form col-md-6 form-group" style="justify-content: end">
                  <input type="text" formControlName="telInput" class="form-control" placeholder="phone number" />
                  <div *ngIf="
                      form.telInput.errors &&
                      (form.telInput.dirty || form.telInput.touched)
                    " class="invalid-feedback">
                    <div *ngIf="form.telInput.errors.required" i18n="@@validation.phone.required">
                      PhoneNumber is required
                    </div>
                    <div *ngIf="form.telInput.errors.pattern" i18n="@@validation.phone.invalid">
                      PhoneNumber is invalid
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-4 modalBodyAside">
            <p class="mb-4 modify text-color text-uppercase add-user ml-3">
              <b i18n="@@admin.users.addroles">add user roles</b>
            </p>
            <div *ngFor="let role of userRole; index as i" class="row ml-3">
              <input type="button" class="btn btn-outline-primary btn-role" [disabled]="!role.canSet" [ngClass]="{
                  'background-color': this.selectedRole.includes(role.roleName)
                }" (click)="getSelectedRole(role, $event)" value="{{ role.roleName }}" />
            </div>
          </div>
        </div>
        <div class="modalFooter">
          <img src="assets/Keen&Wise_save.png" class="saveBtn waves-effect" [ngClass]="{ disabled: !saveButtonActive }"
            (click)="addUser()" />
        </div>
      </div>
    </div>
  </div>
</div>